import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import { formatDuration } from "@/i18n/format";
import { useSecondsSince } from "../progress/useSecondsSince";

/** How long a research run has been going ("2m 5s elapsed"). Kept out of the stage's live region. */
export function Elapsed({ startedAt }: Readonly<{ startedAt: string }>) {
  const { t } = useTranslation("chat", { keyPrefix: "research.progress" });
  const seconds = useSecondsSince(startedAt);
  return (
    <Text as="span" variant="caption" tone="tertiary" className="shrink-0">
      {t("elapsed", { time: formatDuration(Math.floor(seconds)) })}
    </Text>
  );
}
